import React from 'react'
import Content from '../__toolbarContent/schedule__toolbarContent'
import Sidebar from 'blocks.app/sidebar/sidebar'
import Icon from 'blocks.simple/icon/icon'
import { RootStateOrAny, useSelector } from 'react-redux'
import translate from 'core/translate'
import helpersSchedule from 'core/helpers/_schedule'
import styles from './schedule__toolbar.jcss'
import { getParamsForLink } from 'core/helpers/user'
import { MenuItem } from '../../displays/__toolbarContent/displays__toolbarContent'
import { SidebarMultiselectMenu } from '../../../blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'

const ScheduleToolbar = (p_: any) => {
    const userState: any = useSelector<RootStateOrAny>((state) => state.user)
    const schedule: any = useSelector<RootStateOrAny>((state) => state.schedule)
    const allSchedules = schedule.allSchedules
    const eventsByDate = schedule.eventsByDate
    const selectedEventId = schedule.selectedEventId
    const selectedDates = schedule.selectedDates
    const selectedDate = schedule.selectedDate
    const user = userState.data
    const tokens = userState.tokens
    const mainUser = userState.mainUser
    const params = getParamsForLink(tokens, mainUser.id, user.id)
    const downloadLink = helpersSchedule.getDownloadLink(selectedDates, params)
    const isSelectedDates = selectedDates.length === 0

    const BottomContent = () => (
        <div>
            <SidebarMultiselectMenu>
                <div>
                    {downloadLink && (
                        <a className={styles.menuItem} href={downloadLink}>
                            {translate('download')}
                        </a>
                    )}
                </div>
            </SidebarMultiselectMenu>
        </div>
    )

    return (
        <Sidebar
            selectedSide="right"
            side="right"
            content={
                isSelectedDates
                    ? null
                    : {
                          right: {
                              title: translate('selectedSchedules'),
                              options: selectedDates,
                              downloadLink,
                          },
                      }
            }
            customContent={{
                right: isSelectedDates ? (
                    <Content
                        eventsByDate={eventsByDate}
                        allSchedules={allSchedules}
                        selectedDate={selectedDate}
                        selectedEventId={selectedEventId}
                    />
                ) : null,
            }}
            onChange={(list: any, side: any) => {
                if (side === 'right') {
                    p_.onChange(list)
                }
            }}
            topContent={{
                right: isSelectedDates ? null : <BottomContent />,
            }}
            isEmpty={{
                right: false,
            }}
            onSelectInfo={() => {}}
        />
    )
}

export default ScheduleToolbar
